export interface IChannel {
  id: number;
  team: number;
  team_name: string;
  channel: string;
}

export interface ICheckBox {
  id: number;
  name: string;
  isSelect: boolean;
}

export enum Etabs {
  users = 'users',
  channels = 'channels',
}

interface IActionSetListst {
  type: 'setUsersAndChannelsLists';
  payload: { usersList: ICheckBox[]; channelsList: ICheckBox[] };
}

interface IToggleCheckBox {
  type: 'toggleCheckBox';
  payload: { id: number; value: boolean };
}

interface IActionLosding {
  type: 'loading';
}

interface ISwitchTabs {
  type: 'switchTabs';
  payload: { activeTab: Etabs };
}

interface ISearch {
  type: 'search';
  payload: { text: string };
}

interface IInitModal {
  type: 'initModal';
}
export type IActionTypes = IActionSetListst | IToggleCheckBox | IActionLosding | ISwitchTabs | ISearch | IInitModal;

export interface IStateType {
  usersList: Array<ICheckBox>;
  channelsList: Array<ICheckBox>;
  usersDisplayedList: Array<ICheckBox>;
  channelsDisplayedList: Array<ICheckBox>;
  isLoading: boolean;
  activeTab: Etabs;
  searchString: string;
}
